import MainPage from 'modules/website/components/MainPage/MainPage'
import React from 'react'

export default function HomeView() {
  return (
    <MainPage/>
  )
}
